export const formatPriceForDisplay = (price: any) => {
    if (price) {
        const trimPrice = price.trim();
        return !isNaN(parseInt(trimPrice[0], 10)) ? `$${trimPrice}` : trimPrice;
    }
    return price;
}